import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-advance-order-support-article',
    template: `
        <ng-container i18n="@@support.articles.advanceOrder">
            <p>It is possible to purchase licenses in advance. When you subsequently enroll students, you can activate these licenses with a single click.</p>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/licenses">License Overview</a>.</span>
                </li>
                <li>
                    <span>
                        At the top you can see how many licenses you currently have available.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/licensesOverview.png" />
                    </span>
                </li>
                <li>
                    <div>
                        <h2>Order additional licenses</h2>
                        <p>With the order form you may order as many licenses as you want. Pay securely online or by bank transfer.</p>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/orderLicenses.png" />

                        <h2>Submit purchase order (PO).</h2>
                        <p>It is also possible to send us your purchase order (PO) by e-mail. After receipt we will create your order.</p>
                        <p>If desired, you can use the <strong>Generate a quote</strong> button to create a price offer for the desired number of licenses.</p>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/submitPO.png" />
                    </div>
                </li>
            </ol>
        </ng-container>
    `
})
export class AdvanceOrderSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
